var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdderDownHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 15,
    viewBox: "0 0 40 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12L3 15V0H0V12Z",
    fill: "#FAE232"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 15,
    transform: "translate(3)",
    fill: "#FAE232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5L20 10L27 5",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12L37 15L37 -2.62268e-07L40 0L40 12Z",
    fill: "#FAE232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdderDownHover);
export default __webpack_public_path__ + "static/media/adder-down-hover.6eac350905c0ca8d36463513833eea72.svg";
export { ForwardRef as ReactComponent };